import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-mobile-list-card',
  templateUrl: './mobile-list-card.component.html',
  styleUrl: './mobile-list-card.component.scss',
})
export class MobileListCardComponent {

  
}
